import Game from "./Game";
import { SCENES } from "../constants/scenes";
import { MAPS } from "../constants/maps";

export default class SecondLevel extends Game {
  constructor() {
    super(SCENES.SECOND_LEVEL, MAPS.secondLevel.key);
  }
}
